import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/user';
import Layout from '@/layout/index.vue';
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
        meta: { title: '登录', hidden: true }
    },
    // 免登录公共页面：报障提交与查询
    {
        path: '/public/incident-report',
        name: 'PublicIncidentReport',
        component: () => import('@/views/public/IncidentReport.vue'),
        meta: { title: '报障提交', hidden: true, public: true }
    },
    {
        path: '/public/incident-query',
        name: 'PublicIncidentQuery',
        component: () => import('@/views/public/IncidentQuery.vue'),
        meta: { title: '报障查询', hidden: true, public: true }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () => import('@/views/dashboard/index.vue'),
                meta: { title: '仪表盘', icon: 'Dashboard' }
            }
        ]
    },
    {
        path: '/clients',
        component: Layout,
        redirect: '/clients/incidents',
        meta: { title: '客户端管理', icon: 'Monitor', requiresGroupManagement: true, alwaysShow: true },
        children: [
            {
                path: '',
                name: 'Clients',
                component: () => import('@/views/clients/indexV2.vue'),
                meta: { title: '客户端列表', icon: 'Monitor', requiresGroupManagement: true, hidden: true, activeMenu: '/clients' }
            },
            {
                path: 'incidents',
                name: 'ClientIncidents',
                component: () => import('@/views/clients/Incidents.vue'),
                meta: { title: '报障列表', icon: 'Document', requiresGroupManagement: true }
            },
            // {
            //   path: 'v1',
            //   name: 'ClientsV1',
            //   component: () => import('@/views/clients/index.vue'),
            //   meta: { title: '客户端管理(V1)', hidden: true, requiresGroupManagement: true }
            // },
            {
                path: ':clientId',
                name: 'ClientDetail',
                component: () => import('@/views/clients/ClientDetail.vue'),
                meta: { title: '客户端详情', hidden: true, requiresGroupManagement: true, activeMenu: '/clients' }
            }
        ]
    },
    {
        path: '/tunnels',
        component: Layout,
        children: [
            {
                path: '',
                name: 'Tunnels',
                component: () => import('@/views/tunnels/index.vue'),
                meta: { title: '隧道管理', icon: 'Connection' }
            }
        ]
    },
    {
        path: '/groups',
        component: Layout,
        redirect: '/groups/management',
        meta: { title: '客户端组', icon: 'Collection' },
        children: [
            {
                path: 'management',
                name: 'Groups',
                component: () => import('@/views/groups/index.vue'),
                meta: { title: '组管理', icon: 'Setting', requiresGroupManagement: true }
            },
            {
                path: 'health-stats',
                name: 'GroupsHealthStats',
                component: () => import('@/views/groups/health-stats.vue'),
                meta: { title: '组健康监控', icon: 'TrendCharts', requiresGroupManagement: true }
            },
            {
                path: ':id/health-detail',
                name: 'GroupHealthDetail',
                component: () => import('@/views/groups/health-detail.vue'),
                meta: { title: '组健康详情', hidden: true, requiresGroupManagement: true }
            }
        ]
    },
    {
        path: '/devices',
        component: Layout,
        redirect: '/devices/pending',
        meta: { title: '设备管理', icon: 'Cpu', requiresDeviceManagement: true },
        children: [
            {
                path: 'pending',
                name: 'DevicesPending',
                component: () => import('@/views/devices/pending.vue'),
                meta: { title: '待审核设备', icon: 'Clock', requiresDeviceManagement: true }
            },
            {
                path: 'approved',
                name: 'DevicesApproved',
                component: () => import('@/views/devices/approved.vue'),
                meta: { title: '已审核设备', icon: 'Select', requiresDeviceManagement: true }
            },
            {
                path: 'statistics',
                name: 'DevicesStatistics',
                component: () => import('@/views/devices/statistics.vue'),
                meta: { title: '有效期统计', icon: 'DataAnalysis', requiresDeviceManagement: true }
            }
        ]
    },
    {
        path: '/health',
        component: Layout,
        redirect: '/health/groups',
        meta: { title: '健康监控', icon: 'TrendCharts' },
        children: [
            {
                path: 'groups',
                name: 'HealthOverview',
                component: () => import('@/views/health-v2/GroupOverviewV2.vue'),
                meta: { title: '组管理', icon: 'Collection', version: 'v2' }
            },
            {
                path: 'groups/:id',
                name: 'GroupDetail',
                component: () => import('@/views/health/GroupDetail.vue'),
                meta: { title: '组详情', hidden: true }
            },
            {
                path: 'alerts',
                name: 'HealthAlerts',
                component: () => import('@/views/health/Alerts.vue'),
                meta: { title: '健康告警', icon: 'Bell' }
            }
        ]
    },
    {
        path: '/system',
        component: Layout,
        redirect: '/system/users',
        meta: { title: '系统管理', icon: 'Setting', requiresSystemManagement: true },
        children: [
            {
                path: 'users',
                name: 'SystemUsers',
                component: () => import('@/views/system/users.vue'),
                meta: { title: '用户管理', icon: 'User', requiresSystemManagement: true }
            },
            {
                path: 'group-types',
                name: 'SystemGroupTypes',
                component: () => import('@/views/system/group-types.vue'),
                meta: { title: '组类型管理', icon: 'Collection', requiresSystemManagement: true }
            },
            {
                path: 'logs',
                name: 'SystemLogs',
                component: () => import('@/views/logs/index.vue'),
                meta: { title: '日志管理', icon: 'Document', requiresSystemManagement: true }
            }
        ]
    },
    // 移动端路由配置
    {
        path: '/mobile',
        redirect: '/mobile/groups',
        meta: { title: '移动端', hidden: true }
    },
    {
        path: '/mobile/groups',
        name: 'MobileGroupList',
        component: () => import('@/views/mobile/MobileGroupList.vue'),
        meta: { title: '组列表', hidden: true, mobile: true }
    },
    {
        path: '/mobile/groups/:id',
        name: 'MobileGroupDetail',
        component: () => import('@/views/mobile/MobileGroupDetail.vue'),
        meta: { title: '组详情', hidden: true, mobile: true }
    },
    {
        path: '/mobile/clients/:id',
        name: 'MobileClientDetail',
        component: () => import('@/views/mobile/MobileClientDetail.vue'),
        meta: { title: '客户端详情', hidden: true, mobile: true }
    }
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
// 路由守卫
router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore();
    // 初始化认证状态
    if (!userStore.isLoggedIn) {
        userStore.initAuth();
    }
    // 免登录公共页面直接放行
    if (to.path.startsWith('/public') || to.meta?.public) {
        next();
        return;
    }
    // 健康监控路由已静态配置为V2版本
    if (userStore.isLoggedIn) {
        console.log('🚩 健康评分系统版本: V2 (新版本)');
    }
    // 如果是登录页面
    if (to.path === '/login') {
        // 如果已经登录，根据设备类型重定向
        if (userStore.isLoggedIn) {
            try {
                const { getPostLoginRoute } = await import('@/utils/deviceDetection');
                next(getPostLoginRoute());
            }
            catch (error) {
                console.error('Failed to load device detection:', error);
                next('/');
            }
        }
        else {
            next();
        }
        return;
    }
    // 其他页面需要登录
    if (!userStore.isLoggedIn) {
        next('/login');
        return;
    }
    // 移动端路由权限检查
    if (to.meta?.mobile) {
        // 移动端路由不需要额外的权限检查，只需要登录即可
        next();
        return;
    }
    // 检查系统管理权限
    if (to.meta?.requiresAdmin || to.meta?.requiresSystemManagement) {
        // 检查是否有系统管理权限
        if (!userStore.isAdmin && !userStore.hasSystemManagementPermission) {
            // 没有系统管理权限，重定向到首页
            next('/');
            return;
        }
    }
    // 检查设备管理权限
    if (to.meta?.requiresDeviceManagement) {
        // 检查是否有设备管理权限
        if (!userStore.isAdmin && !userStore.hasDeviceManagementPermission) {
            // 没有设备管理权限，重定向到首页
            next('/');
            return;
        }
    }
    // 检查组管理权限
    if (to.meta?.requiresGroupManagement) {
        // 检查是否有组管理权限
        if (!userStore.isAdmin && !userStore.hasGroupManagementPermission) {
            // 没有组管理权限，重定向到首页
            next('/');
            return;
        }
    }
    next();
});
/**
 * 获取用户组信息
 */
function getUserGroups(userStore) {
    const groups = [];
    if (userStore.isAdmin) {
        groups.push('admin');
    }
    if (userStore.hasSystemManagementPermission) {
        groups.push('system-admin');
    }
    if (userStore.hasGroupManagementPermission) {
        groups.push('group-admin');
    }
    if (userStore.hasDeviceManagementPermission) {
        groups.push('device-admin');
    }
    // 检查是否是测试用户
    if (userStore.user?.email?.includes('test') || userStore.user?.username?.includes('test')) {
        groups.push('beta-testers');
    }
    // 检查是否是开发者
    if (userStore.user?.role === 'developer' || userStore.user?.email?.includes('dev')) {
        groups.push('developers');
    }
    return groups;
}
export default router;
